import { c as createFastContext } from '../../utils/createFastContext.js';

var initialState = {
  width: null,
  height: null
};
var _createFastContext = createFastContext(initialState),
  BiomeWindowSizeProvider = _createFastContext.Provider,
  useWindowSizeStore = _createFastContext.useStore;
BiomeWindowSizeProvider.displayName = "BiomeWindowSizeProvider";

export { BiomeWindowSizeProvider as B, useWindowSizeStore as u };
//# sourceMappingURL=windowSizeContext.js.map
